import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';

// components and helpers

// mui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { CircularProgress } from '@mui/material';

interface MappingPreviewProps {
    rows: any;
    headers: string[];
    mappedFields: any;
}

const MappingPreview: React.FC<MappingPreviewProps> = ({
    rows,
    mappedFields,
    headers,
}) => {
    const [mappedColumns, setMappedColumns] = useState([]);
    const [mappedRows, setMappedRows] = useState([]);
    const options = {
        download: false,
        elevation: 0,
        filter: false,
        pagination: false,
        print: false,
        search: false,
        sort: false,
        sortFilterList: false,
        viewColumns: false,
        selectableRowsHeader: false,
        selectableRowsHideCheckboxes: true,
        textLabels: {
            body: {
                noMatch: 'Dataset too large to preview',
            },
        },
    };

    useEffect(() => {
        const columns = [];
        const data = [{}, {}];
        for (const [key, value] of Object.entries(mappedFields)) {
            if (value !== null) {
                columns.push({
                    name: key,
                    label: key,
                });
                if (rows && rows.length && rows[0] && rows[0].length) {
                    // eslint-disable-next-line array-callback-return
                    rows.map((row, i) => {
                        data[i][key] = row[value as number];
                    });
                    setMappedRows(data);
                }
            }
        }

        setMappedColumns(columns);
    }, [mappedFields, headers, rows]);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography
                    variant={'body1'}
                    sx={{ textAlign: 'center' }}
                    color={'secondary'}
                >
                    Please review the following preview of the first 2 rows of
                    your file with the newly mapped headers.
                </Typography>
                <Divider sx={{ m: 2 }} />
                {!rows || rows.length === 0 ? (
                    <Grid container justifyContent={'center'}>
                        <Grid item>
                            <CircularProgress />
                        </Grid>
                    </Grid>
                ) : (
                    <MUIDataTable
                        title={''}
                        data={mappedRows}
                        columns={mappedColumns}
                        options={options}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default MappingPreview;
